<template>
  <v-toolbar class="c-navbar">
    <router-link :to="{name: 'home'}"><img src="@/assets/Logo_header.png" height="40"/></router-link>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <v-btn text v-for="item in items" :key="item.title" :to="{ name: item.name }">{{item.title}}</v-btn>
      <v-btn text small @click="logout">
        {{ username }}
        <v-icon >lock_open</v-icon>
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex';

import { AUTH_LOGOUT } from '@/store/actions/auth';

import RoleFiltering from '@/mixins/RoleFiltering';


export default {
  name: 'NavBar',

  mixins: [
    RoleFiltering
  ],

  data: () => ({
    navItems: [
      {
        title: 'Clients',
        name: 'clientList',
        roleGuard: 'admin'
      },
      {
        title: 'Fournisseurs',
        name: 'providerList',
        roleGuard: 'admin'
      },
      {
        title: 'Vins',
        name: 'wineList',
        roleGuard: ['admin', 'client', 'producer']
      },
      {
        title: 'Machines',
        name: 'machineList',
        roleGuard: ['admin', 'client']
      }
    ]
  }),

  methods: {
    logout () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$router.push({ name: 'login' });
      });
    }
  },
  computed: {
    ...mapState({
      username: state => `${state.auth.data.username} (${state.auth.data.role})`
    }),
    items () {
      let out = [];
      for (let i of this.navItems) {
        if (this.hasRole(i.roleGuard)) {
          out.push(i);
        }
      }
      return out;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-navbar {
  background-color: #000;
}
</style>
